// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2v5tl","filesListContainer":"PosDisputesFiles_filesListContainer__3uBa_","filesButton":"PosDisputesFiles_filesButton__38hrC"};